import React from 'react';
import ResetPwPopup from '../MyComponents/ResetPassword/ResetPwPopup';

const ForgotPasswordPage = () => {
  // Always open the popup on this page
  return <ResetPwPopup isOpen={true} onClose={() => {}} />;
};

export default ForgotPasswordPage; 